import { useCallback } from "react";

import cn from "@utils/cn";
import Router from "@utils/Router";
import { toastify } from "@vendors";
import { useAsyncRequest } from "@hooks";
import ActionMenuBaseItem from "@components/action_menu/item_types/ActionMenuBaseItem";

// TODO: Add callback functionality from useOperation

const CLASS_NAMES = cn(`
  text-[#8A1010]!
  bg-[#F9ECEC]!
  hover:text-[#8A1010]!
  hover:bg-[#F9ECEC]!
  focus:text-[#8A1010]!
  focus:bg-[#F3D8D8]!
  active:text-[#8A1010]!
  active:bg-[#EFCCCC]!

  aria-disabled:text-[#AC8989]!
  aria-disabled:bg-[#F9ECEC]!
  aria-disabled:hover:text-[#AC8989]!
  aria-disabled:hover:bg-[#F9ECEC]!
  aria-disabled:focus:text-[#AC8989]!
  aria-disabled:focus:bg-[#F9ECEC]!
  aria-disabled:active:text-[#AC8989]!
  aria-disabled:active:bg-[#F9ECEC]!
`);

const DISABLED_TEXT_CLASS_NAMES = cn(`
  text-[#BC9C9C]!
`);

export default function ActionMenuRecordDeletionItem(props) {
  const {
    record,
    // callback,
    confirmationMessage = "Are you sure you want to delete?",
    onDeleteSuccessMessage = "Record deletion succeeded!",
    onDeleteFailureMessage = "Record deletion failed!",
  } = props;

  /**************************************************************************************************/

  // TODO: Get Record ID & Resource Key/Record Type and then use getResourceConfig to get the resource
  // const resource = getResourceConfig(record.type);

  const handleExecuteDeletionSuccess = useCallback((data) => {
    const deletedRecord = data?.records;

    if (deletedRecord.id) {
      toastify.onReload({ type: "success", value: onDeleteSuccessMessage });
      Router.redirectToPath(`/${record.type}`);
    } else {
      toastify.onReload({ type: "error", value: onDeleteFailureMessage });
      Router.redirectToPath(`/${record.type}/${record.id}`);
    }
  }, [onDeleteSuccessMessage, onDeleteFailureMessage, record.type, record.id]);

  const handleExecuteDeletionFailure = useCallback((error) => {
    toastify.error("Error!");
    console.error(error);
  }, []);

  const executeDeletion = useAsyncRequest({
    path: `/${record.type}/${record.id}`,
    method: "DELETE",
    onSuccess: handleExecuteDeletionSuccess,
    onFailure: handleExecuteDeletionFailure,
  });

  const handleClick = useCallback((event) => {
    event.keepOpen = true;

    if (window.confirm(confirmationMessage)) {
      executeDeletion();
    }
  }, [confirmationMessage, executeDeletion]);

  /**************************************************************************************************/

  return (
    <ActionMenuBaseItem
      className={CLASS_NAMES}
      onClick={handleClick}
      label={{
        text: "Delete",
        icon: "trash-can",
      }}
      disabledTextClassName={DISABLED_TEXT_CLASS_NAMES}
      {...props}
    />
  );
};
